import SwipeCardInfo from './SwipeCardInfo';

export default SwipeCardInfo;
